import moment, { Moment } from "moment-timezone";
import { PayPeriod } from "../PayPeriod";
import { PayPeriodInterval } from "../PayPeriodInterval";
import { NotImplementedError } from "../NotImplementedError";

export function getEndOfPayPeriodInterval(payInterval: PayPeriodInterval, timezone: string): Moment {
  if (payInterval.period === PayPeriod.Monthly) {
    return moment.tz(payInterval.startsOn, timezone).endOf('month');
  }
  throw new NotImplementedError(payInterval.period);
}
